import { motion } from 'framer-motion';
import React, { useState, useRef } from 'react';
import { FontAwesomeConfigurations } from '../../../../utils/Configuration/FontAwesomeConfiguration';
import PushNotificationHandler from '../../../../utils/PushNotificationHandler';
import JUNOActionMenu from '../../../components/JUNOActionMenu';
import useOutsideAlerter from '../../../hooks/useOutsideAlerter';

interface UpdatesContainerProps {
  collapsedStates;
  setCollapsedStates;
  numUnreadNotis;
  setNumUnreadMessages;
  numUnreadMessages;
  containerRef;
  onBlur;
}
const UpdatesContainer: React.FC<UpdatesContainerProps> = ({ ...props }) => {
  const handleOnCollapse = position => {
    const updatedCollapsedState = props.collapsedStates.map((item, index) => (index === position ? !item : item));
    props.setCollapsedStates(updatedCollapsedState);
  };
  const [isOpen, setIsOpen] = useState(false);
  const updatesRef = useRef(null);
  const onClickOpen = e => {
    setIsOpen(old => !old);
  };
  useOutsideAlerter(updatesRef, e => {
    console.log('react fired');
    setIsOpen(false);
  });

  // TODO future
  // const allowNotificationSnoozing = CrowdHub_App.CONFIG.ALLOW_NOTIFICATION_SNOOZING;
  // let snoozeTimes = CrowdHub_App.CONFIG.NOTIFICATION_SNOOZE_TIMES;
  // if (PushNotificationHandler.USER_SNOOZED_NOTIFICATIONS) {
  //   snoozeTimes = [{ snooze_time: -1, action_text: 'Resume Notifications' }];
  // }
  // let actionHeaders = [{ order: 0, text: 'Pause Notifications' }];
  // let actionItems = [{}];
  // snoozeTimes.forEach((snooze, index) => {
  //   actionItems.push({
  //     header: 0,
  //     order: index,
  //     id: snooze.snooze_time,
  //     text: snooze.action_text,
  //     icon: '',
  //     onclick: () => {
  //       if (PushNotificationHandler.USER_SNOOZED_NOTIFICATIONS) {
  //         PubNubCenter.INSTANCE?.dispatch(PubNubCenter.ON_UNSNOOZE_NOTIFICATIONS, this, {});
  //       } else {
  //         PubNubCenter.INSTANCE?.dispatch(PubNubCenter.ON_SNOOZE_NOTIFICATIONS, this, {
  //           snooze_time: snooze.snooze_time,
  //         });
  //       }
  //       setIsOpen(false);
  //     },
  //   });
  // });
  return (
    <div className={`updates_container`}>
      <div className={`header ${props.collapsedStates[1] ? 'visible' : ''}`} onClick={e => handleOnCollapse(1)}>
        <span>
          Updates
          <span className={`updates_count ${props.numUnreadNotis + props.numUnreadMessages > 0 ? 'brand_color' : ''}`}>
            <i
              className={`${props.numUnreadNotis + props.numUnreadMessages == 0 ? 'hidden' : ''} brand_color small ${
                FontAwesomeConfigurations.ICON_CIRCLE_SOLID
              }`}
            ></i>
          </span>
        </span>
        <i className={`collapse_icon ${FontAwesomeConfigurations.ICON_MINUS} fa-fw`} />
        <i className={`expand_icon ${FontAwesomeConfigurations.ICON_CHEVRON_DOWN} fa-fw`} />
      </div>
      <motion.div
        className="dropdown_items_container"
        variants={dropdown}
        initial={`hidden`}
        animate={props.collapsedStates[1] ? 'visible' : 'hidden'}
        style={{ y: 12 }}
        ref={props.containerRef}
      >
        <button
          className="dropdown_item"
          aria-label={CrowdHub_App.LANG.PROFILE_DROPDOWN_NOTIFICATIONS}
          onClick={e => {
            let url = App.INSTANCE.appRouter.generate('navigate.notifications');
            App.INSTANCE.route(url);
            props.onBlur();
          }}
          tabIndex={0}
          style={{ border: 'none' }}
        >
          <div className="icon">
            <i className={`${FontAwesomeConfigurations.ICON_BELL}`}></i>
            {/* TODO future */}
            {/* <i
              className={`${allowNotificationSnoozing ? 'on-hover-default' : ''} ${
                FontAwesomeConfigurations.ICON_BELL
              }`}
            ></i> */}
            {/* <div className={`JUNO_action_menu ${allowNotificationSnoozing ? 'on-hover' : ''}`}>
              <motion.div
                key={`action_menu_${moment.now()}`}
                onClick={onClickOpen}
                className={`action_menu_icon ${isOpen ? 'open' : ''}`}
              >
                <i className={`${FontAwesomeConfigurations.ICON_ELLIPSIS_VERTICAL}`}></i>
              </motion.div>
              {isOpen && <div className={`action_menu_mobile_bg`}></div>}
              <motion.div
                className={`action_menu_dropdown ${isOpen ? 'open' : ''}`}
                variants={dropdown}
                initial={`hidden`}
                animate={isOpen ? 'visible' : 'hidden'}
                style={{ y: 0, x: 0 }}
                ref={updatesRef}
                onMouseLeave={e => {
                  setIsOpen(false);
                }}
              >
                <JUNOActionMenu items={actionItems} headers={actionHeaders} />
              </motion.div>
            </div> */}
          </div>
          <div className="text">{CrowdHub_App.LANG.PROFILE_DROPDOWN_NOTIFICATIONS}</div>
          <span className={`update_num small ${props.numUnreadNotis == 0 ? 'hidden' : ''}`}>
            {props.numUnreadNotis > 99 ? '99+' : props.numUnreadNotis}
          </span>
        </button>

        <button
          className="dropdown_item"
          onClick={e => {
            let url = App.INSTANCE.appRouter.generate('navigate.messagesmodule', { tab: 'chat', conversation: -1 });
            App.INSTANCE.route(url);
            props.onBlur();
            props.setNumUnreadMessages(0);
          }}
          aria-label={CrowdHub_App.LANG.PROFILE_DROPDOWN_MESSAGES}
          tabIndex={0}
          style={{ border: 'none' }}
        >
          <div className="icon">
            <i className={`${FontAwesomeConfigurations.ICON_COMMENT}`}></i>
            {/* TODO future */}
            {/* <i
              className={`${allowNotificationSnoozing ? 'on-hover-default' : ''} ${
                FontAwesomeConfigurations.ICON_COMMENT
              }`}
            ></i> */}
            {/* <div className={`JUNO_action_menu ${allowNotificationSnoozing ? 'on-hover' : ''}`}>
              <motion.div
                key={`action_menu_${moment.now()}`}
                onClick={onClickOpen}
                className={`action_menu_icon ${isOpen ? 'open' : ''}`}
              >
                <i className={`${FontAwesomeConfigurations.ICON_ELLIPSIS_VERTICAL}`}></i>
              </motion.div>
              {isOpen && <div className={`action_menu_mobile_bg`}></div>}
              <motion.div
                className={`action_menu_dropdown ${isOpen ? 'open' : ''}`}
                variants={dropdown}
                initial={`hidden`}
                animate={isOpen ? 'visible' : 'hidden'}
                style={{ y: 0, x: 0 }}
                ref={updatesRef}
                onMouseLeave={e => {
                  setIsOpen(false);
                }}
              >
                <JUNOActionMenu items={actionItems} headers={actionHeaders} />
              </motion.div>
            </div> */}
          </div>
          <div className="text">{CrowdHub_App.LANG.PROFILE_DROPDOWN_MESSAGES}</div>
          <span className={`update_num small ${props.numUnreadMessages == 0 ? 'hidden' : ''}`}>
            {props.numUnreadMessages > 99 ? '99+' : props.numUnreadMessages}
          </span>
        </button>
      </motion.div>
    </div>
  );
};

const dropdown = {
  hidden: {
    opacity: 0,
    transition: { duration: 0.15 },
    display: 'none',
  },
  visible: {
    y: 0,
    opacity: 1,
    transition: { duration: 0.15 },
    display: 'flex',
  },
};

export default UpdatesContainer;
